import {useContext, useEffect} from 'react'
import {ModalFooterContext} from './Modal.jsx'

export default function useScrollOnError(error) {
    const ctx = useContext(ModalFooterContext)
    useEffect(() => {
        if (error && ctx?.scrollToBottom) ctx.scrollToBottom()
    }, [error, ctx])
}
